import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowDownProps = IconComponentBaseProps;

export const ArrowDown = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: ArrowDownProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_904_21127"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill={fill} />
      </mask>
      <g mask="url(#mask0_904_21127)">
        <path
          d="M8.00096 10.1601L13.1446 5.01664C13.2428 4.91831 13.3603 4.86975 13.4971 4.87097C13.6339 4.87231 13.7514 4.92214 13.8496 5.02047C13.948 5.1187 13.9971 5.2362 13.9971 5.37297C13.9971 5.50975 13.948 5.62725 13.8496 5.72547L8.75862 10.8205C8.65096 10.9281 8.5309 11.0068 8.39846 11.0563C8.2659 11.1059 8.1334 11.1306 8.00096 11.1306C7.86851 11.1306 7.73601 11.1059 7.60346 11.0563C7.47101 11.0068 7.35096 10.9281 7.24329 10.8205L2.14846 5.72547C2.05012 5.62725 2.00162 5.50908 2.00296 5.37097C2.00418 5.23297 2.05396 5.11486 2.15229 5.01664C2.25051 4.91831 2.36801 4.86914 2.50479 4.86914C2.64157 4.86914 2.75907 4.91831 2.85729 5.01664L8.00096 10.1601Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
